import { SanctionStatusEnum } from "@repo/graphql/gql/graphql";

export const CREATOR_SANCTION_MESSAGE =
  "Este creador se encuentra suspendido por incumplimientos.";

export function isCreatorSanctioned(
  status: SanctionStatusEnum | null | undefined,
): boolean {
  return Boolean(status && status !== SanctionStatusEnum.None);
}
